import React from 'react'
import { Modal } from '../../../components/Modal/Modal'
import { Button } from '../../../components/Button/Button'

export interface SendEmailConfirmationModalProps {
  show: boolean
  onConfirm: () => void
  onHide: () => void
}

export const SendEmailConfirmationModal: React.FC<SendEmailConfirmationModalProps> = ({ show, onConfirm, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={
        <div className='d-flex flex-column zocks-gap-3'>
          <h4 className='text-center'>Are you sure you want to send this e-mail?</h4>
        </div>
      }
      footer={
        <div className='d-flex flex-grow-1 gap-3 align-items-center'>
          <Button variant='secondary' className='flex-grow-1' onClick={onHide}>
            Cancel
          </Button>
          <Button variant='primary' className='flex-grow-1' onClick={onConfirm}>
            Send
          </Button>
        </div>
      }
      centered={true}
    />
  )
}
